import React, { useState } from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { SaveIcon, EyeIcon, EyeOffIcon, DownloadIcon, PlusIcon, TrashIcon, FileTextIcon, FileSpreadsheetIcon, FileIcon, UploadIcon, CheckCircleIcon, XCircleIcon, ChevronLeftIcon, ChevronRightIcon, AlertCircleIcon } from 'lucide-react';
export function IntegrazioneGestionaliTab() {
  const [showPassword, setShowPassword] = useState(false);
  const [importMode, setImportMode] = useState('manuale');
  const [allowNewEntries, setAllowNewEntries] = useState(false);
  const [ftpConfig] = useState({
    server: 'ftp.cashfirst.cloud',
    username: 'acme_import',
    password: 'p@ssw0rd123!'
  });
  const [timeBlocks, setTimeBlocks] = useState([{
    id: 1,
    hour: '08',
    minute: '00'
  }]);
  const [currentPage, setCurrentPage] = useState(1);
  const logsPerPage = 20;
  // Dati di esempio per i log
  const [logs] = useState([{
    id: 1,
    timestamp: '2023-06-15 08:00:12',
    type: 'file caricato',
    status: 'success',
    filename: 'scadenze_20230615.csv',
    message: 'File caricato con successo'
  }, {
    id: 2,
    timestamp: '2023-06-15 08:00:14',
    type: 'import tracciato',
    status: 'success',
    filename: 'scadenze_20230615.csv',
    message: 'Importazione completata: 156 record elaborati'
  }, {
    id: 3,
    timestamp: '2023-06-15 12:15:00',
    type: 'file caricato',
    status: 'success',
    filename: 'clienti_20230615.csv',
    message: 'File caricato con successo'
  }, {
    id: 4,
    timestamp: '2023-06-15 12:15:02',
    type: 'import tracciato',
    status: 'failed',
    filename: 'clienti_20230615.csv',
    message: 'Errore alla riga 23: formato data non valido (15/06/2023)'
  }, {
    id: 5,
    timestamp: '2023-06-16 08:00:09',
    type: 'file caricato',
    status: 'success',
    filename: 'scadenze_20230616.csv',
    message: 'File caricato con successo'
  }, {
    id: 6,
    timestamp: '2023-06-16 08:00:11',
    type: 'import tracciato',
    status: 'success',
    filename: 'scadenze_20230616.csv',
    message: 'Importazione completata: 142 record elaborati'
  }, {
    id: 7,
    timestamp: '2023-06-16 12:15:03',
    type: 'file caricato',
    status: 'success',
    filename: 'clienti_20230616.csv',
    message: 'File caricato con successo'
  }, {
    id: 8,
    timestamp: '2023-06-16 12:15:05',
    type: 'import tracciato',
    status: 'failed',
    filename: 'clienti_20230616.csv',
    message: 'Errore alla riga 45: codice fiscale non valido (ABCDEF12G34H567I)'
  }, {
    id: 9,
    timestamp: '2023-06-17 08:00:08',
    type: 'file caricato',
    status: 'success',
    filename: 'scadenze_20230617.csv',
    message: 'File caricato con successo'
  }, {
    id: 10,
    timestamp: '2023-06-17 08:00:10',
    type: 'import tracciato',
    status: 'success',
    filename: 'scadenze_20230617.csv',
    message: 'Importazione completata: 168 record elaborati'
  }, {
    id: 11,
    timestamp: '2023-06-17 12:15:02',
    type: 'file caricato',
    status: 'success',
    filename: 'clienti_20230617.csv',
    message: 'File caricato con successo'
  }, {
    id: 12,
    timestamp: '2023-06-17 12:15:04',
    type: 'import tracciato',
    status: 'success',
    filename: 'clienti_20230617.csv',
    message: 'Importazione completata: 12 record elaborati'
  }, {
    id: 13,
    timestamp: '2023-06-18 08:00:11',
    type: 'file caricato',
    status: 'success',
    filename: 'scadenze_20230618.csv',
    message: 'File caricato con successo'
  }, {
    id: 14,
    timestamp: '2023-06-18 08:00:13',
    type: 'import tracciato',
    status: 'failed',
    filename: 'scadenze_20230618.csv',
    message: 'Errore alla riga 78: importo non valido (1.234,56.78)'
  }, {
    id: 15,
    timestamp: '2023-06-18 12:15:04',
    type: 'file caricato',
    status: 'success',
    filename: 'clienti_20230618.csv',
    message: 'File caricato con successo'
  }, {
    id: 16,
    timestamp: '2023-06-18 12:15:06',
    type: 'import tracciato',
    status: 'success',
    filename: 'clienti_20230618.csv',
    message: 'Importazione completata: 5 record elaborati'
  }, {
    id: 17,
    timestamp: '2023-06-19 08:00:10',
    type: 'file caricato',
    status: 'success',
    filename: 'scadenze_20230619.csv',
    message: 'File caricato con successo'
  }, {
    id: 18,
    timestamp: '2023-06-19 08:00:12',
    type: 'import tracciato',
    status: 'success',
    filename: 'scadenze_20230619.csv',
    message: 'Importazione completata: 175 record elaborati'
  }, {
    id: 19,
    timestamp: '2023-06-19 12:15:05',
    type: 'file caricato',
    status: 'success',
    filename: 'clienti_20230619.csv',
    message: 'File caricato con successo'
  }, {
    id: 20,
    timestamp: '2023-06-19 12:15:07',
    type: 'import tracciato',
    status: 'success',
    filename: 'clienti_20230619.csv',
    message: 'Importazione completata: 8 record elaborati'
  }, {
    id: 21,
    timestamp: '2023-06-20 08:00:09',
    type: 'file caricato',
    status: 'success',
    filename: 'scadenze_20230620.csv',
    message: 'File caricato con successo'
  }, {
    id: 22,
    timestamp: '2023-06-20 08:00:11',
    type: 'import tracciato',
    status: 'failed',
    filename: 'scadenze_20230620.csv',
    message: 'Errore alla riga 42: cliente non trovato (ID: 12345)'
  }, {
    id: 23,
    timestamp: '2023-06-20 12:15:03',
    type: 'file caricato',
    status: 'success',
    filename: 'clienti_20230620.csv',
    message: 'File caricato con successo'
  }, {
    id: 24,
    timestamp: '2023-06-20 12:15:05',
    type: 'import tracciato',
    status: 'success',
    filename: 'clienti_20230620.csv',
    message: 'Importazione completata: 15 record elaborati'
  }, {
    id: 25,
    timestamp: '2023-06-21 08:00:12',
    type: 'file caricato',
    status: 'success',
    filename: 'scadenze_20230621.csv',
    message: 'File caricato con successo'
  }]);
  // Calcolo per la paginazione
  const totalPages = Math.ceil(logs.length / logsPerPage);
  const indexOfLastLog = currentPage * logsPerPage;
  const indexOfFirstLog = indexOfLastLog - logsPerPage;
  const currentLogs = logs.slice(indexOfFirstLog, indexOfLastLog);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const handleAddTimeBlock = () => {
    if (timeBlocks.length >= 10) {
      alert('Hai raggiunto il limite massimo di 10 blocchi orari');
      return;
    }
    const newId = Math.max(0, ...timeBlocks.map(block => block.id)) + 1;
    setTimeBlocks([...timeBlocks, {
      id: newId,
      hour: '12',
      minute: '00'
    }]);
  };
  const handleRemoveTimeBlock = id => {
    setTimeBlocks(timeBlocks.filter(block => block.id !== id));
  };
  const handleTimeChange = (id, field, value) => {
    setTimeBlocks(timeBlocks.map(block => block.id === id ? {
      ...block,
      [field]: value
    } : block));
  };
  const handleImportModeChange = e => {
    setImportMode(e.target.value);
  };
  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
  };
  const handleAllowNewEntriesChange = e => {
    setAllowNewEntries(e.target.checked);
  };
  return <Card data-id="element-1222">
      <h3 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1223">
        Integrazione con Gestionali
      </h3>
      {/* Selettore modalità di importazione */}
      <div className="mb-8" data-id="element-1224">
        <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1225">
          Modalità di importazione
        </h4>
        <div className="space-y-4" data-id="element-1226">
          <div data-id="element-1227">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1228">
              Seleziona la modalità di importazione dei dati
            </label>
            <div className="mt-2 space-y-4" data-id="element-1229">
              <div className="flex items-center" data-id="element-1230">
                <input id="import-manuale" name="import-mode" type="radio" value="manuale" checked={importMode === 'manuale'} onChange={handleImportModeChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-1231" />
                <label htmlFor="import-manuale" className="ml-3 block text-sm font-medium text-gray-700" data-id="element-1232">
                  Importazione manuale (caricamento file)
                </label>
              </div>
              <div className="flex items-center" data-id="element-1233">
                <input id="import-automatico" name="import-mode" type="radio" value="automatico" checked={importMode === 'automatico'} onChange={handleImportModeChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300" data-id="element-1234" />
                <label htmlFor="import-automatico" className="ml-3 block text-sm font-medium text-gray-700" data-id="element-1235">
                  Importazione automatica (FTP)
                </label>
              </div>
            </div>
            <p className="mt-2 text-sm text-gray-500" data-id="element-1236">
              {importMode === 'manuale' ? "L'importazione manuale richiede il caricamento dei file direttamente dalla pagina Scadenze." : "L'importazione automatica preleva i file dal server FTP secondo gli orari configurati."}
            </p>
          </div>
        </div>
      </div>
      {/* Configurazione FTP - visibile solo se modalità automatica */}
      {importMode === 'automatico' && <>
          <div className="mb-8" data-id="element-1237">
            <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1238">
              Dati di accesso FTP
            </h4>
            <p className="text-sm text-gray-500 mb-4" data-id="element-1239">
              Utilizza questi dati per configurare il tuo gestionale per l'invio
              automatico dei file.
            </p>
            <div className="space-y-4" data-id="element-1240">
              <div data-id="element-1241">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1242">
                  Server FTP
                </label>
                <input type="text" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md bg-gray-50" value={ftpConfig.server} readOnly data-id="element-1243" />
              </div>
              <div data-id="element-1244">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1245">
                  Username
                </label>
                <input type="text" className="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md bg-gray-50" value={ftpConfig.username} readOnly data-id="element-1246" />
              </div>
              <div data-id="element-1247">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1248">
                  Password
                </label>
                <div className="mt-1 relative rounded-md shadow-sm" data-id="element-1249">
                  <input type={showPassword ? 'text' : 'password'} className="focus:ring-blue-500 focus:border-blue-500 block w-full pr-10 sm:text-sm border-gray-300 rounded-md bg-gray-50" value={ftpConfig.password} readOnly data-id="element-1250" />
                  <div className="absolute inset-y-0 right-0 pr-3 flex items-center" data-id="element-1251">
                    <button type="button" onClick={togglePasswordVisibility} className="text-gray-400 hover:text-gray-500 focus:outline-none" data-id="element-1252">
                      {showPassword ? <EyeOffIcon className="h-5 w-5" data-id="element-1253" /> : <EyeIcon className="h-5 w-5" data-id="element-1254" />}
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-4" data-id="element-1255">
                <div className="flex items-center" data-id="element-1256">
                  <input id="allow-new-entries" name="allow-new-entries" type="checkbox" checked={allowNewEntries} onChange={handleAllowNewEntriesChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded" data-id="element-1257" />
                  <label htmlFor="allow-new-entries" className="ml-2 block text-sm text-gray-700" data-id="element-1258">
                    Permetti di inserire da CashFirst nuove anagrafiche
                    (sconsigliato)
                  </label>
                </div>
                {allowNewEntries && <div className="mt-2 rounded-md bg-yellow-50 p-3" data-id="element-1259">
                    <div className="flex" data-id="element-1260">
                      <div className="flex-shrink-0" data-id="element-1261">
                        <AlertCircleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" data-id="element-1262" />
                      </div>
                      <div className="ml-3" data-id="element-1263">
                        <p className="text-sm text-yellow-700" data-id="element-1264">
                          Questa opzione potrebbe creare disallineamenti con il
                          gestionale. Si consiglia di mantenere il gestionale
                          come fonte primaria dei dati anagrafici.
                        </p>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
          {/* Orari di importazione - visibile solo se modalità automatica */}
          <div className="mb-8" data-id="element-1265">
            <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1266">
              Orari di importazione
            </h4>
            <p className="text-sm text-gray-500 mb-4" data-id="element-1267">
              Configura gli orari in cui il sistema verificherà la presenza di
              nuovi file da importare. Puoi impostare fino a 10 orari diversi.
            </p>
            <div className="space-y-4" data-id="element-1268">
              {timeBlocks.map(block => <div key={block.id} className="flex items-center space-x-3" data-id="element-1269">
                  <div className="flex-grow flex space-x-2" data-id="element-1270">
                    <div className="w-1/2" data-id="element-1271">
                      <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1272">
                        Ora
                      </label>
                      <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={block.hour} onChange={e => handleTimeChange(block.id, 'hour', e.target.value)} data-id="element-1273">
                        {Array.from({
                    length: 24
                  }, (_, i) => String(i).padStart(2, '0')).map(hour => <option key={hour} value={hour} data-id="element-1274">
                            {hour}
                          </option>)}
                      </select>
                    </div>
                    <div className="w-1/2" data-id="element-1275">
                      <label className="block text-xs font-medium text-gray-700 mb-1" data-id="element-1276">
                        Minuti
                      </label>
                      <select className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md" value={block.minute} onChange={e => handleTimeChange(block.id, 'minute', e.target.value)} data-id="element-1277">
                        {['00', '15', '30', '45'].map(minute => <option key={minute} value={minute} data-id="element-1278">
                            {minute}
                          </option>)}
                      </select>
                    </div>
                  </div>
                  {timeBlocks.length > 1 && <Button variant="tertiary" className="self-end mb-1" onClick={() => handleRemoveTimeBlock(block.id)} data-id="element-1279">
                      <TrashIcon className="h-4 w-4 text-red-500" data-id="element-1280" />
                    </Button>}
                </div>)}
              {timeBlocks.length < 10 && <Button type="button" variant="secondary" icon={<PlusIcon className="h-4 w-4 mr-2" data-id="element-1282" />} onClick={handleAddTimeBlock} className="mt-2" data-id="element-1281">
                  Aggiungi orario
                </Button>}
            </div>
          </div>
        </>}
      {/* Documentazione */}
      <div className="mb-8" data-id="element-1283">
        <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1284">
          Documentazione
        </h4>
        <p className="text-sm text-gray-500 mb-4" data-id="element-1285">
          Scarica i file con il tracciato record e le istruzioni per
          l'integrazione.
        </p>
        <div className="space-y-3" data-id="element-1286">
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-md" data-id="element-1287">
            <div className="flex items-center" data-id="element-1288">
              <FileSpreadsheetIcon className="h-5 w-5 text-green-600 mr-2" data-id="element-1289" />
              <span className="text-sm text-gray-700" data-id="element-1290">
                Tracciato record (Excel)
              </span>
            </div>
            <Button variant="secondary" icon={<DownloadIcon className="h-4 w-4 mr-2" data-id="element-1292" />} onClick={() => alert('Download avviato')} data-id="element-1291">
              Scarica
            </Button>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-md" data-id="element-1293">
            <div className="flex items-center" data-id="element-1294">
              <FileIcon className="h-5 w-5 text-blue-600 mr-2" data-id="element-1295" />
              <span className="text-sm text-gray-700" data-id="element-1296">
                Tracciato record (CSV)
              </span>
            </div>
            <Button variant="secondary" icon={<DownloadIcon className="h-4 w-4 mr-2" data-id="element-1298" />} onClick={() => alert('Download avviato')} data-id="element-1297">
              Scarica
            </Button>
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-50 rounded-md" data-id="element-1299">
            <div className="flex items-center" data-id="element-1300">
              <FileTextIcon className="h-5 w-5 text-red-600 mr-2" data-id="element-1301" />
              <span className="text-sm text-gray-700" data-id="element-1302">
                Manuale di integrazione (PDF)
              </span>
            </div>
            <Button variant="secondary" icon={<DownloadIcon className="h-4 w-4 mr-2" data-id="element-1304" />} onClick={() => alert('Download avviato')} data-id="element-1303">
              Scarica
            </Button>
          </div>
        </div>
      </div>
      {/* Log di sincronizzazione */}
      <div className="mb-8" data-id="element-1305">
        <h4 className="text-md font-medium text-gray-900 mb-4" data-id="element-1306">
          Log di sincronizzazione
        </h4>
        <p className="text-sm text-gray-500 mb-4" data-id="element-1307">
          Ultime operazioni di importazione ed elaborazione dei file.
        </p>
        <div className="overflow-x-auto" data-id="element-1308">
          <table className="min-w-full divide-y divide-gray-300" data-id="element-1309">
            <thead className="bg-gray-50" data-id="element-1310">
              <tr data-id="element-1311">
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-1312">
                  Data e Ora
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-1313">
                  Operazione
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-1314">
                  File
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-1315">
                  Stato
                </th>
                <th scope="col" className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900" data-id="element-1316">
                  Dettaglio
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1317">
              {currentLogs.map(log => <tr key={log.id} className={log.status === 'failed' ? 'bg-red-50' : ''} data-id="element-1318">
                  <td className="px-3 py-4 text-sm text-gray-500 whitespace-nowrap" data-id="element-1319">
                    {log.timestamp}
                  </td>
                  <td className="px-3 py-4 text-sm text-gray-500" data-id="element-1320">
                    {log.type}
                  </td>
                  <td className="px-3 py-4 text-sm text-gray-500" data-id="element-1321">
                    {log.filename}
                  </td>
                  <td className="px-3 py-4 text-sm" data-id="element-1322">
                    {log.status === 'success' ? <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800" data-id="element-1323">
                        <CheckCircleIcon className="h-3.5 w-3.5 mr-1" data-id="element-1324" />
                        Success
                      </span> : <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800" data-id="element-1325">
                        <XCircleIcon className="h-3.5 w-3.5 mr-1" data-id="element-1326" />
                        Failed
                      </span>}
                  </td>
                  <td className="px-3 py-4 text-sm text-gray-500" data-id="element-1327">
                    {log.message}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Paginazione */}
        <div className="px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-1328">
          <div className="flex-1 flex justify-between sm:hidden" data-id="element-1329">
            <Button variant="secondary" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} data-id="element-1330">
              Precedente
            </Button>
            <Button variant="secondary" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} data-id="element-1331">
              Successivo
            </Button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-1332">
            <div data-id="element-1333">
              <p className="text-sm text-gray-700" data-id="element-1334">
                Visualizzazione{' '}
                <span className="font-medium" data-id="element-1335">{indexOfFirstLog + 1}</span> a{' '}
                <span className="font-medium" data-id="element-1336">
                  {Math.min(indexOfLastLog, logs.length)}
                </span>{' '}
                di <span className="font-medium" data-id="element-1337">{logs.length}</span> risultati
              </p>
            </div>
            <div data-id="element-1338">
              <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-1339">
                <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${currentPage === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-1340">
                  <span className="sr-only" data-id="element-1341">Precedente</span>
                  <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-1342" />
                </button>
                {/* Pulsanti pagina */}
                {[...Array(totalPages)].map((_, i) => <button key={i} onClick={() => handlePageChange(i + 1)} className={`relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium ${currentPage === i + 1 ? 'z-10 bg-blue-50 border-blue-500 text-blue-600' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-1343">
                    {i + 1}
                  </button>)}
                <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${currentPage === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-1344">
                  <span className="sr-only" data-id="element-1345">Successivo</span>
                  <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-1346" />
                </button>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end" data-id="element-1347">
        <Button type="button" icon={<SaveIcon className="h-4 w-4 mr-2" data-id="element-1349" />} onClick={() => alert('Configurazione salvata con successo')} data-id="element-1348">
          Salva Configurazione
        </Button>
      </div>
    </Card>;
}